import { useEffect } from 'react';

import { createHook, createStore, type StoreActionApi } from 'react-sweet-state';

import ProfileClient from '@atlaskit/profilecard/client';

import { useAppConfig } from '../app-config-context';
import { useCloudId } from '../site';

interface State {
	profileClient?: ProfileClient;
}

type StoreApi = StoreActionApi<State>;
type Actions = typeof actions;

const CACHE_MAX_AGE = 60 * 1000;

const actions = {
	createClient:
		(stargateRoot: string, enableTeamCentral = false, cloudId?: string) =>
		({ setState }: StoreApi): ProfileClient => {
			const profileClient = new ProfileClient({
				gatewayGraphqlUrl: `${stargateRoot}/graphql`,
				url: `${stargateRoot}/directory/graphql`,
				teamCentralDisabled: !enableTeamCentral,
				// teamCentralBaseUrl: enableTeamCentral
				//   ? getConfig().teamCentralUrl
				//   : undefined,
				cacheSize: 20,
				cacheMaxAge: CACHE_MAX_AGE,
				cloudId,
			});

			setState({ profileClient });

			return profileClient;
		},
};

const ProfileClientStore = createStore<State, Actions>({
	initialState: {},
	actions,
});

const useProfileClientState = createHook(ProfileClientStore);

export const useProfileClient = ({
	enableTeamCentral = false,
}: {
	enableTeamCentral?: boolean | undefined;
} = {}): State['profileClient'] => {
	const [{ profileClient }, { createClient }] = useProfileClientState();
	const { stargateRoot } = useAppConfig();
	const cloudId = useCloudId();

	useEffect(() => {
		createClient(stargateRoot, enableTeamCentral, cloudId);
	}, [createClient, stargateRoot, cloudId, enableTeamCentral]);

	return profileClient;
};
